import { FigureShopify } from '@studiometa/ui';

/**
 * Figure component for lazy loading images with Shopify CDN
 */
export default class Figure extends FigureShopify {
  static config = {
    ...FigureShopify.config,
    name: 'Figure',
  };

  /**
   * Debug: log mounted event
   */
  async mounted() {
    const { img } = this.$refs;
    console.log('[Figure] mounted', {
      src: img?.src,
      dataSrc: img?.dataset.src,
      offsetWidth: img?.offsetWidth,
      offsetHeight: img?.offsetHeight,
      lazy: this.$options.lazy,
    });
    return super.mounted();
  }
}
